export const SENTRY_EVENTS = {
    ON_SENTRY_ERROR: 'onSentryError',
    ON_SENTRY_MESSAGE: 'onSentryMessage',
    ON_SENTRY_EVENT: 'onSentryEvent'
};

export const SENTRY_GLOBAL_COMPONENT = 'SentryGlobalEventEmitter';